import {
  ButtonThemes,
  CheckCircleIcon,
  Col,
  EditIcon,
  Modal,
  ModalSizes,
  Row,
  TimesCircleIcon,
} from 'plataforma-fundacao-componentes';

import FaceDown from 'components/Icons/FaceDown';
import FaceUp from 'components/Icons/FaceUp';
import { clsx } from 'helpers/utils/HTMLUtils';
import translation from 'locales/translation';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useCallback, useState } from 'react';
import styles from './styles.module.scss';
import './styles.scss';

interface IProps extends ModalProps {
  onCancel?: any;
  onConfirm?: (e?: any) => Promise<void>;
  error?: boolean;
}

const modalReservationPrefix = translation.Assessor.Modal.Reservation;

export const ReservationAlert = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    props.onClose && props.onClose(props.modalKey);
  }, [props]);

  return (
    <Modal
      className={clsx([styles.root, !props.error ? 'outer' : ''])}
      title={modalReservationPrefix.Title}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={handleClose}
      size={ModalSizes.Large}
      footer={
        props.error
          ? [
              {
                theme: ButtonThemes.Primary,
                leftIcon: <EditIcon />,
                children: modalReservationPrefix.buttons.voltarEdicao,
                onClick: () => props.onClose!(props.modalKey),
              },
            ]
          : [
              {
                theme: ButtonThemes.Secondary,
                leftIcon: <TimesCircleIcon />,
                children: modalReservationPrefix.buttons.reservarSair,
                onClick: () => {
                  props.onCancel();
                  props.onClose!(props.modalKey);
                },
              },
              {
                theme: ButtonThemes.Primary,
                leftIcon: <CheckCircleIcon />,
                children: modalReservationPrefix.buttons.continuarCadastramento,
                loading: loading,
                disabled: loading,
                onClick: () => {
                  setLoading(true);
                  return new Promise<any>(
                    (resolve: (evt?: any) => void, _: () => void) => {
                      if (typeof props.onConfirm === 'function') {
                        props
                          .onConfirm()
                          .then(() => {
                            resolve();
                            setLoading(false);

                            props.onClose!(props.modalKey);
                          })
                          .catch(() => {
                            setLoading(false);
                          })
                          .finally(() => {
                            setLoading(false);
                          });
                      }
                    }
                  );
                },
              },
            ]
      }
    >
      <Row>
        <Col cols={[2, 2, 2, 2, 2]} noPadding>
          {props.error ? <FaceDown /> : <FaceUp />}
        </Col>
        <Col cols={[10, 10, 10, 10, 10]} noPadding>
          {props.error ? (
            <div>
              <h1>{modalReservationPrefix.Error.title}</h1>
              <p>{modalReservationPrefix.Error.body()}</p>
              <div className={styles.divider} />
              <span>
                Em caso de dúvidas entre em contato conosco pelo Suporte da
                Fundação através do{' '}
                <a
                  href='https://chat.sicredi.com.br'
                  target={'_blank'}
                  rel='noreferrer'
                >
                  chat.sicredi.com.br
                </a>{' '}
                ou <b>Voip 8000 opção 7</b>
              </span>
            </div>
          ) : (
            <div>
              <h1>{modalReservationPrefix.Success.title}</h1>
              {modalReservationPrefix.Success.body()}
            </div>
          )}
        </Col>
      </Row>
    </Modal>
  );
};
